module.exports = __webpack_public_path__ + "img/welcomes-preview-text-vip.6b825150.png";